import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import zh from "./locales/zh.json";

const SUPPORTED_LANGUAGES = ["en", "zh"] as const;
type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const FALLBACK_LANGUAGE: SupportedLanguage = "en";
const LANGUAGE_LABELS: Record<
  SupportedLanguage,
  { title: string; htmlLang: string }
> = {
  en: {
    title: "KbDeviationFrom - Market Extreme Divergence Monitor",
    htmlLang: "en",
  },
  zh: {
    title: "KbDeviationFrom - 全市场极值背离监控",
    htmlLang: "zh-CN",
  },
};

export function normalizeLanguage(language?: string | null): SupportedLanguage {
  if (!language) return FALLBACK_LANGUAGE;
  const normalized = language.toLowerCase();
  if (normalized.startsWith("zh")) return "zh";
  if (normalized.startsWith("en")) return "en";
  return FALLBACK_LANGUAGE;
}

export function syncDocumentLanguage(language?: string | null) {
  if (typeof document === "undefined") return;

  const normalized = normalizeLanguage(language);
  const config = LANGUAGE_LABELS[normalized];
  document.documentElement.lang = config.htmlLang;
  document.title = config.title;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      zh: { translation: zh },
    },
    supportedLngs: [...SUPPORTED_LANGUAGES],
    fallbackLng: FALLBACK_LANGUAGE,
    defaultNS: "translation",
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: {
      order: ["navigator", "localStorage"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
      convertDetectedLanguage: (language: string) =>
        normalizeLanguage(language),
    },
  });

syncDocumentLanguage(i18n.resolvedLanguage ?? i18n.language);

i18n.on("languageChanged", syncDocumentLanguage);

export default i18n;
